import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Env, Offers } from '@contexts/AppContext';
import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { ContentType, Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { Newsletter } from '@utils/backend-api/newsletters';

import Content from './Content';

const queryClient = new QueryClient();

interface NewsletterFeedBannerProps {
  env: Env;
  feedType: string;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  offers?: Offers;
  newsletter: Newsletter;
}

const NewsletterFeedBanner = ({
  env,
  feedType,
  initialCurrentUser,
  isGdprRequired,
  offers,
  newsletter,
}: NewsletterFeedBannerProps) => {
  const { Track } = useEventTracking({
    page: Page.NewsletterFeed,
    contentType: ContentType.Newsletter,
    contentId: newsletter.id,
  });
  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        env={env}
        offers={offers}
      >
        <QueryClientProvider client={queryClient}>
          <Content feedType={feedType} newsletter={newsletter} />
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default NewsletterFeedBanner;
